export enum AdminPage {
  Landing,
  BookForm
}
